import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { VentaComponent } from './venta/venta.component';
import { FooterComponent } from '../shared/footer/footer.component';
import { BuscarComponent } from './buscar/buscar.component';
import { HeaderComponent } from '../shared/header/header.component';
import { RemesaComponent } from './remesa/remesa.component';
import { SalidasComponent } from './salidas/salidas.component';
import { OpcionesModule } from '../opciones/opciones.module';


@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right'
    }),
    OpcionesModule
  ],
  exports: [
    HomeComponent,
    LoginComponent,
    VentaComponent,
    BuscarComponent,
    HeaderComponent,
  ],
  declarations: [
    HomeComponent,
    LoginComponent,
    VentaComponent,
    FooterComponent,
    BuscarComponent,
    HeaderComponent,
    RemesaComponent,
    SalidasComponent,
  ]
})
export class PagesModule { }
